import { useEffect } from "react";

import { extractAnalyticsUser } from "./extract-analytics-user";
import { useAnalyticsUserPersistence } from "./use-analytics-user-persistence";
import { useUser } from "./use-user";

export function useUserEffect(): void {
  const { user } = useUser();
  const { upsertUser } = useAnalyticsUserPersistence();

  useEffect(() => {
    upsertUser(extractAnalyticsUser(user));
  }, [user, upsertUser]);
}
